export const ACTIONS = {
  SET_THEME: "SET_THEME",
};
